// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import React, { FC } from "react";

export interface CartSpecialOrderMessageProps extends WidgetProps {}

const CartSpecialOrderMessage: FC<CartSpecialOrderMessageProps> = () => {
    const cart = useAppSelector(state => getCurrentCartState(state).value);
    const isLoading = useAppSelector(state => state.data.carts.isLoading);

    if (!cart || (cart.lineCount && !cart.cartLines) || isLoading[cart.id]) {
        return null;
    }

    const hasSpecialOrderProduct = cart.cartLines?.some(line => line.properties?.availabilityOrderAsNeeded === "True");

    if (!hasSpecialOrderProduct) {
        return null;
    }

    return <InfosBox>{translate("Grimco_Cart_SpecialOrderMessage")}</InfosBox>;
};

const widgetModule: WidgetModule = {
    component: CartSpecialOrderMessage,
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
    },
};

export default widgetModule;
